import { CampaignListEntry } from '@features/campaign-list/slice/schemas';
import { CampaignListRow, LoadableTrendEntry } from './columns';
import { TrendEntry } from '@features/campaign-list/configuration/lci3-mini-chart-options';

const trendDataOrLoading = (
  trendData: TrendEntry[],
  loading: boolean
): LoadableTrendEntry =>
  loading ? { status: 'loading' } : { status: 'loaded', data: trendData };

export const campaignListRowFromPayload = (
  campaignPayload: CampaignListEntry,
  visitTrend: TrendEntry[],
  salesTrend: TrendEntry[],
  loading: boolean
): CampaignListRow => {
  return {
    ...campaignPayload,
    partner: campaignPayload.partnerSlug ?? undefined,
    incrementalVisitsTrending: trendDataOrLoading(visitTrend, loading),
    incrementalSalesTrending: trendDataOrLoading(salesTrend, loading),
    download: {
      campaignId: campaignPayload.campaignId,
      reportId: campaignPayload.reportId,
      salesReportId: campaignPayload.latestReportIdWithSales,
      reportType: campaignPayload.reportType,
      campaignName: campaignPayload.campaignName,
      getCampaignParams: {
        id: campaignPayload.campaignId,
        custom_report_id:
          campaignPayload.reportType === 'custom'
            ? campaignPayload.reportId
            : undefined,
        include_unapproved: false,
      },
    },
  };
};
